import { Provider } from "react-redux";
import { ApolloProvider } from "react-apollo";
import client from "../../helpers/apollo-client";
import React from "react";
import store from "../../stores/reduxStore";

import Icon_List from "./iconlist";

export default class Icon_List_Parent extends React.Component {
    render() {
        // this component exists to pass the redux store to the legacy iconlist component
        return (
            <ApolloProvider client={client}>
                <Provider store={store}>
                    <Icon_List args={this.props.args} />
                </Provider>
            </ApolloProvider>
        );
    }
}
